import { useMutation, useQueryClient } from "@tanstack/react-query";

import { deleteAttendanceAttachment } from "@/adapters/api";
import { useActiveContext } from "@/store/use-active-context";
import { invalidateAttendance } from "./invalidate-attendance";

export interface DeleteAttachmentInput {
	workerId: string;
	date: string;
	attachmentId: string;
}

export function useDeleteAttachment() {
	const queryClient = useQueryClient();
	const activeCanteiroId = useActiveContext((state) => state.activeCanteiroId);

	return useMutation({
		mutationFn: (input: DeleteAttachmentInput) =>
			deleteAttendanceAttachment(
				activeCanteiroId as string,
				input.workerId,
				input.date,
				input.attachmentId,
			),
		onSuccess: () => invalidateAttendance(queryClient),
	});
}
